module.exports = __webpack_public_path__ + "static/img/banner6_mb.2164c419.png";